import React from "react";
import { useHistory, useLocation } from "react-router-dom";

const TABS = [
  { label: "Cuentas",      path: "/dashboard/crm"              },
{ label: "Tareas",       path: "/dashboard/crm/tareas"        },
  { label: "Prospección",  path: "/dashboard/crm/prospeccion"   },
];

const CRMNav = () => {
  const history  = useHistory();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/dashboard/crm") {
      // Exacto, no incluye subrutas como /crm/oportunidades, /crm/tareas, /crm/prospeccion
      return location.pathname === "/dashboard/crm";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div style={{
      display: "flex", gap: 4,
      borderBottom: "2px solid #f0e6ec",
      marginBottom: 28,
    }}>
      {TABS.map((tab) => {
        const active = isActive(tab.path);
        return (
          <button
            key={tab.path}
            onClick={() => history.push(tab.path)}
            style={{
              padding: "10px 22px",
              background: "none",
              border: "none",
              borderBottom: active ? "2px solid #9f0059" : "2px solid transparent",
              marginBottom: -2,
              fontSize: 14,
              fontWeight: active ? 700 : 500,
              color: active ? "#9f0059" : "#888",
              cursor: "pointer",
              transition: "color 0.15s",
              whiteSpace: "nowrap",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default CRMNav;
